import React, { useMemo } from 'react';
import CustomSearch from '../../components/common/CustomSearch';
import Grid from '../../components/layout/grid/Grid';
import CustomSwitch from '../../components/common/CustomSwitch';
import { changeAdvisorCategoryAccessFn } from '../../Services/advisorService';

const CategoryTab = ({ data, setDep ,id }) => {
  console.log('categorytab', data);

  const { normalizedData, advisorId } = useMemo(() => {
    const accessMap = {};
    let extractedAdvisorId = null;
  

    data.forEach(item => {
      console.log('item',item);
      if (item.advisor_id && typeof item.category_id === 'object') {
        const catId = item.category_id.category_id;
        accessMap[catId] = {
          is_access: item.is_access,
        };
        extractedAdvisorId = item.advisor_id;
      }
    });
  

    const categories = data
      .filter(item => typeof item.category_id === 'string')
      .map(category => {
        console.log('check',category);
        
        const access = accessMap[category.category_id];
        // console.log('access for',category?.is_access);
  
        return {
          category_id: category.category_id,
          title: category.title,
          is_access: access?.is_access || false,
        };
      });
  
    console.log('cata', categories);
    console.log('access', accessMap);
    
  
    return {
      normalizedData: categories,
      advisorId: extractedAdvisorId,
    };
  }, [data]);
  

  const handleCompanyAccessToggle = async (categoryId, currentAccess) => {
    if (!advisorId) {
      const payload = {
        advisor_category_access_array: [
          {
            advisor_id: id,
            category_id: categoryId,
            is_access: !currentAccess,
          },
        ],
      };
      try {
        const res = await changeAdvisorCategoryAccessFn(payload);
        console.log('Access updated:', res?.data);
        setDep(prev => !prev);
      } catch (err) {
        console.error('Error updating access:', err);
      }
    }
    else{

      const payload = {
        advisor_category_access_array: [
          {
            advisor_id: advisorId,
            category_id: categoryId,
            is_access: !currentAccess,
          },
        ],
      };
  
      try {
        const res = await changeAdvisorCategoryAccessFn(payload);
        console.log('Access updated:', res?.data);
        setDep(prev => !prev);
      } catch (err) {
        console.error('Error updating access:', err);
      }
    }

  };

  return (
    <div>
      

      <Grid container className="flex m-2">
        {console.log('normalizedData', normalizedData)}
        
        {normalizedData.map((item) => (
          <Grid
            key={item.category_id}
            item
            xs={4}
            className="border border-[#E2EBF3] rounded-md m-2"
          >
            <div className="flex items-center justify-start p-2">
              <CustomSwitch
                name={item.title.toLowerCase().replace(/\s+/g, '-')}
                value={item.is_access}
                onChange={() => handleCompanyAccessToggle(item.category_id, item.is_access)}
              />
              <span className="ml-2 font-semibold">{item.title}</span>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CategoryTab;
